module.exports = __webpack_public_path__ + "static/mack_after-97077224f711e324fa3e88592a3cdca0.jpg";